// extracted by mini-css-extract-plugin
module.exports = {"Root":"PrescriptionSplitView_Root__1U8LE","Map":"PrescriptionSplitView_Map__1UAZx","Svg":"PrescriptionSplitView_Svg__3GtmJ","Handle":"PrescriptionSplitView_Handle__2pE40"};